import React, { useState } from 'react'

// components
import Heading from '../../../components/text/Heading/Heading.component'

// collections
import CrewListWithSearch from './collections/CrewListTable/CrewListTable.collection'

// forms
import CreateCrewMemberFormController from './forms/CreateCrewMember.form.controller'

// wrappers
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper'

// query
import { GET_ALL_CREW_MEMBERS_WITH_FULL_DETAIL } from '../../../graphql/crewMember/crewMember.queries'

// mui
import { Typography, Grid, Container } from '@mui/material'

export default function CrewList({ ...pageProps }) {
    const [showAddModal, setShowAddModal] = useState(false)
    // const [filterValue, setFilterValue] = useState(null)

    return (<div id="CrewList">
        <CreateCrewMemberFormController 
            visible={showAddModal}
            closeForm={() => setShowAddModal(false)}
        />

        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent="center">
                <Grid item xs={6}><Typography variant="h2">Crew</Typography></Grid>
            </Grid>
        </Container>

        <WithGqlQuery 
            component={CrewListWithSearch}
            query={ GET_ALL_CREW_MEMBERS_WITH_FULL_DETAIL }
            onAddClick={() => setShowAddModal(true)}
            pageProps={pageProps}
        />
    </div>)
}